import permissions from './permission-list'

export default [
  {
    path: '/categories',
    name: 'categories',
    component: () => import('@/views/categories/index.vue'),
    meta: {
      pageTitle: 'Daftar Kategori',
      resource: permissions.category,
      action: 'read',
      navActiveLink: 'categories',
      breadcrumb: [
        {
          text: 'Kategori',
          active: true,
        },
      ],
    },
  },
  {
    path: '/categories/create',
    name: 'categories-create',
    component: () => import('@/views/categories/create.vue'),
    meta: {
      pageTitle: 'Buat Kategori',
      resource: permissions.category,
      action: 'manage',
      navActiveLink: 'categories',
      breadcrumb: [
        {
          text: 'Kategori',
          active: false,
          to: { path: '/categories' },
        },
        {
          text: 'Buat',
          active: true,
        },
      ],
    },
  },
  {
    path: '/categories/:id/edit',
    name: 'categories-edit',
    component: () => import('@/views/categories/edit.vue'),
    meta: {
      pageTitle: 'Edit Kategori',
      resource: permissions.category,
      action: 'manage',
      navActiveLink: 'categories',
      breadcrumb: [
        {
          text: 'Kategori',
          active: false,
          to: { path: '/categories' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
